<kendo-dialog
  [title]="title | i18n"
  *ngIf="opened"
  (close)="onClose(dialogResult.Cancel)"
  [maxWidth]="450"
>
  <p style="margin: 30px; text-align: center">
    {{ content | i18n }}
  </p>
  <kendo-dialog-actions>
    <button kendoButton (click)="onClose(dialogResult.No)" *ngIf="showNoButton">
      {{ noButtonText | i18n }}
    </button>
    <button kendoButton (click)="onClose(dialogResult.Yes)" themeColor="primary" *ngIf="showYesButton">
      {{ yesButtonText | i18n }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
